<template>
  <div class="designs-container">
    <CRow class="mb-4">
      <CCol class="col-8">
        <div class="dropdown_wrapper"></div>
      </CCol>
      <CCol class="col-4">
        <b-button v-b-modal.modal-1 class="float-right mb-3" variant="primary">Create Container</b-button>
      </CCol>
    </CRow>
    <CRow>
      <CCol class="col-12 float-end">
        <search-items v-model="search_term" :searchHandler="SearchContainer" :placeholder="'Type to search containers by name'"></search-items>
      </CCol>
    </CRow>
    <CRow class="align-items-center" v-if="containers && containers.length == 0">
      <CCol>
        No data exists
      </CCol>
    </CRow>
    <CRow v-for="(item, index) in containers" :key="index">
      <CCol class="col-sm-12">
        <CRow class="container_row">
          <CCol class="col-4">{{ item.name }}</CCol>
          <CCol class="col-4">
            {{ getLastUpdated(item.files) }}
          </CCol>
          <CCol class="col-4" v-if="item.files && item.files.length === 0">
            <plus class="actions mr-2" @click="AddFile(item.id)" fillColor="#009FE3" />
          </CCol>
        </CRow>
        <CRow class="files_row">
          <CCol class="col-8">
            <CRow>
              <CCol class="col-6">
                {{item.files && item.files.length > 0 ? item.files[0].file_name : ''}}
              </CCol>
              <CCol class="col-3">
                {{item.files && item.files.length > 0 ? item.files[0].file_size : ''}}
              </CCol>
              <CCol class="col-3">
                <span v-for="(file, file_idx) in item.files" :key="file_idx">
                  <span v-if="file.sku_id">{{ `${file.sku_number}_${file.sku_id}` }},</span>
                </span>
              </CCol>
            </CRow>
          </CCol>
          <CCol class="col-4">
            <template v-if="item.files && item.files.length > 0">
              <router-link :to="{path:'/product-designs/'+item.files[0].id+'/view'}"><eye class="mr-2" fillColor="#009FE3" /></router-link>
              <edit class="mr-2" @click="EditFile(item.id,item.files[0].id)"  fillColor="#009FE3" />
            </template>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <div style="margin-bottom: 10px"></div>

    <b-pagination
        v-model="containerPagination.currentPage"
        :total-rows="containerPagination.rows"
        :per-page="containerPagination.perPage"
        aria-controls="itemList"
        align="center"
        @change="handleContainers"
        v-if="containerPagination.total > 0"
    ></b-pagination>


    <b-modal no-close-on-backdrop hide-footer id="modal-1" title="Add Container">
      <CRow>
        <template v-if="role_name == 'factory'">
          <CCol class="col-12">
            <label class="required">Factory</label>
            <v-select
                v-model="selected_factory"
                v-validate="{required: true}"
                :options="user_factory_options"
                name="user_factory"
                placeholder="Select Factory"
            >
            </v-select>
            <div v-if="errors && errors.first('user_factory')" class="error_msg">
              {{errors.first('user_factory')}}
            </div>
          </CCol>
        </template>

        <CCol class="col-12">
          <label class="required">Name</label>
          <b-input v-validate="{required: true, min: 3}" name="name" v-model="name"></b-input>
          <div v-if="errors && errors.first('name')" class="error_msg">
            {{errors.first('name')}}
          </div>
          <b-button @click="AddContainer" class="mt-2 float-right" variant="primary">Save</b-button>
        </CCol>
      </CRow>
    </b-modal>
    <b-modal no-close-on-backdrop hide-footer id="fileModal" :title="modal_title">
      <CRow>
        <CCol class="col-12">
          <label class="required">Select Design File</label>
          <b-form-file accept=".svg,.zip" @input="showFile" name="file" v-validate="{required: true,}" v-model="file"></b-form-file>
          <div v-if="errors && errors.first('file')" class="error_msg">
            {{errors.first('file')}}
          </div>
          <b-button @click="AddFileDesigns" class="mt-2 float-right" variant="primary">Save</b-button>
        </CCol>
      </CRow>
    </b-modal>
  </div>
</template>
<script>
// import Delete from 'vue-material-design-icons/Delete.vue';
import Edit from 'vue-material-design-icons/Pencil.vue';
import Plus from "vue-material-design-icons/Plus.vue";
import Eye from "vue-material-design-icons/Eye.vue";
import $ from "jquery";
import {http} from "@/config/httpCommon";
import SearchItems from '@/components/SearchItems.vue';
import axios from "axios";
import {setPageModal, extractDesignParts, safeParse} from "@/helpers/Helpers";

export default {
  components: {
    Plus,
    Edit,
    Eye,
    SearchItems,
    // Delete,
  },
  data(){
    return{
      container_id: 0,
      name: '',
      file_type: '',
      file: null,
      file_id: 0,
      is_edit_file:false,
      svg_content: '',
      containers: [],
      common_design:'',
      modal_title:'',
      used_files_name:[],
      file_action:'',
      search_term:'',
      containerPagination:{
        rows:null,
        currentPage:null,
        perPage:null,
        total:0
      },
      user_factory_options:[],
      selected_factory:null,
      container_file_addons_content: null
    }
  },
  async created() {
    await this.$store.dispatch('getUserFactories')
    let user_factories = this.$store.getters.userFactoriesOptions;
    if(user_factories.length > 0){
      this.user_factory_options = user_factories;
      if(this.role_name == 'factory') {
        this.selected_factory = user_factories[0];
      }
    }
    this.preservePaginationIgnoreSearch( 'page', 'search', this.$route.name, this.getContainers);
  },
  methods: {
    // Helper for batching async functions
    async batchProcess(items, batchSize, asyncFn) {
      const results = [];
      for (let i = 0; i < items.length; i += batchSize) {
        const batch = items.slice(i, i + batchSize);
        const batchResults = await Promise.all(batch.map(asyncFn));
        results.push(...batchResults);
      }
      return results;
    },
    async retryGetSignedUrl(payload, retries = 3, delay = 1000) {
      for (let attempt = 0; attempt < retries; attempt++) {
        try {
          const res = await http.post('design-file-s3-url', payload);
          return res;
        } catch (err) {
          const isLastAttempt = attempt === retries - 1;
          const status = err?.response?.status;

          // Only retry on 5xx server errors or network failures
          if (status >= 500 && status < 600 && !isLastAttempt) {
            await new Promise(resolve => setTimeout(resolve, delay));
          } else {
            break;
          }
        }
      }
      return null;
    },
    async retryUploadToSignedUrl(formData, retries = 3, delay = 1000) {
      for (let attempt = 0; attempt < retries; attempt++) {
        try {
          const file = formData.get('file');
          const signed_url = formData.get('signed_url');
          if (!file || !signed_url) {
            throw new Error('Missing "file" or "signed_url" in formData');
          }

          await axios.put(signed_url, file, {
            headers: {
              'Content-Type': file.type
            }
          });
          return true;
        } catch (err) {
          const status = err?.response?.status;
          const isLastAttempt = attempt === retries - 1;
          if (status >= 500 && status < 600 && !isLastAttempt) {
            await new Promise(resolve => setTimeout(resolve, delay));
          } else {
            break;
          }
        }
      }
      return false;
    },
    async postDesignFileWithRetry(payload, retries = 3, delay = 1000) {
      for (let attempt = 0; attempt < retries; attempt++) {
        try {
          const response = await http.post('designfile', payload);
          return response;
        } catch (error) {
          const isServerError = error?.response?.status === 500;
          if (attempt < retries - 1 && isServerError) {
            await new Promise(res => setTimeout(res, delay));
          } else {
            throw error;
          }
        }
      }
    },
    getLastUpdated(files) {
      if (!files || files.length === 0) return "No files";

      const mostRecentFile = files.reduce((latest, file) => {
        const fileDate = new Date(file.updated_at);
        return fileDate > new Date(latest.updated_at) ? file : latest;
      });

      return this.formatDate(mostRecentFile.updated_at);
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    async getContainers(params){
      try {
        this.$store.commit('set', ['showLoader', true]);
        let res = await this.$store.dispatch('getContainer',params);
        this.containerPagination = this.makeContainerPagination(res.data);
        this.containers = res.data.data;
        this.$store.commit('set', ['showLoader', false]);
      }catch (err){
        this.$store.commit('set', ['showLoader', false]);
        this.showError(err);
      }
    },
    // changeFactory(obj){
    //   let params = '?search_term='+this.search_term+'&factory_id='+obj.value;
    //   this.getContainers(params);
    // },
    makeContainerPagination(data){
      this.containerPagination.currentPage = data.meta.current_page;
      this.containerPagination.rows = data.meta.total;
      this.containerPagination.perPage = data.meta.per_page;
      this.containerPagination.total = data.meta.total;
      return this.containerPagination;
    },
    async SearchContainer(){
      let params = '?search_term='+this.search_term;
      /*if(this.selected_factory){
         params += '&factory_id='+this.selected_factory.value
      }*/
      setPageModal(1,this.$route.name,this.search_term);
      this.getContainers(params);
    },
    async handleContainers(page=''){
      setPageModal(page,this.$route.name,this.search_term);
      let params = '?page='+page+'&search_term='+this.search_term;
      /*if(this.selected_factory){
        params += '&factory_id='+this.selected_factory.value
      }*/
      this.getContainers(params);
    },
    showFile(){
      this.name = this.file.name;
      this.file_type = this.name.split('.').pop();

      if(this.file_type=='svg'){
        let reader = new FileReader();
        reader.readAsText(this.file);
        reader.onload = async () => {
          this.svg_content = reader.result;
          await this.extractAddonsFromSvgFile()
        };
        reader.onerror = function() {
          console.log(reader.error);
        };
      }

    },
    async AddContainer() {
      let valid = await this.$validator.validate();
      if (valid) {
        try{
          let payload = { name: this.name,}
          if(this.role_name === 'factory') {
            payload.factory_id = this.selected_factory.value
          }
          let res = await this.$store.dispatch('addContainer', payload);
          if (res.status == 201){
            this.getContainers('');
            this.showToast("Container Created successfully", "SUCCESS")
            this.name = ''
            this.$bvModal.hide("modal-1");
          }
        }catch (err){
          this.showError(err);
        }
      }
    },
    AddFile(id){
      this.container_id = id;
      this.file_id = 0;
      this.$bvModal.show('fileModal');
      this.modal_title = 'Add Design File';
      this.file_action='add';

    },
    EditFile(container_id,file_id){
      this.container_id = container_id;
      this.file_id = file_id;
      this.$bvModal.show('fileModal');
      this.modal_title = 'Edit Design File';
      this.file_action='update';
    },
    hasExtension() {
     let exts = ['.svg', '.zip'];
      return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(this.name);
    },
    async AddFileDesigns(){
     if(!this.hasExtension()){
        this.showToast('Please upload ZIP or SVG file', 'DANGER');
        return false;
      }
      
      if(this.file_type == 'zip'){
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("container_id", this.container_id);
        formData.append("file_id", this.file_id);
        formData.append("name", this.name);
        formData.append("size", this.getReadableFileSizeString(this.file.size));
        try{
          this.$store.commit('set', ['showLoader', true]);
          let res = await this.$store.dispatch('uploadContainerZipFile', formData);
          this.$store.commit('set', ['showLoader', false]);
          this.showToast(res.data.message,'SUCCESS')
          this.$bvModal.hide('fileModal');
          if(res.data.errors.file.length > 0){
            let errorJson = {response:{data:{errors:res.data.errors}}};
            this.showError(errorJson);
          }
        }catch (err){
          this.$store.commit('set', ['showLoader', false]);
          this.showError(err);
        }
      }
      else if (this.file_type == 'svg'){
        const firstIndex = this.svg_content.indexOf('<'); // this first index will the svg tag
        let svgheader = this.svg_content.substr(firstIndex+1, this.svg_content.indexOf('<'));
        let newsvg = '';
        if(svgheader.length <= 0){
          newsvg = '<?xml version="1.0" encoding="utf-8"?>\n' +
              '<svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
              '\t width="3886.9" height="4508.3" viewBox="0 0 3886.9 4508.3" style="enable-background:new 0 0 3886.9 4508.3;" xml:space="preserve">';
        }else{
          newsvg = svgheader;
        }

        let design_name = $(this.svg_content).find('[id^=DESIGN]').attr('id');
        let design_selector = '#' + design_name;

        if($(this.svg_content).find(design_selector).length < 1){
          this.showToast('Invalid SVG file uploaded. Design Tag is missing', 'DANGER');
          return false;
        }

        // Iterate through all elements in the SVG content and remove 'display: none'
        $(this.svg_content).find('*').each((index, element) => {
          this.removeDisplayNone(element); // Call the function to remove display: none
        });


        let front = false; //required
        $(this.svg_content).find(design_selector).children().each((index, design) => {
          
          // Call removeDisplayNone once for each design element
          this.removeDisplayNone(design); // This will handle the design and all its children recursively

          front = false;
          let design_id = $(design).is('[data-name]') ? $(design).attr('data-name') : design.id;
          design.id = design_id.replace(/#.*$|_.*$/g, '');
          $(design).children().each((i, group) => {

            // Call removeDisplayNone once for each group element
            this.removeDisplayNone(group); // This will handle the group and all its children recursively

            let gorup_id = $(group).is('[data-name]') ? $(group).attr('data-name') : group.id;
            group.id = gorup_id.split('_')[0];
            if(group.id.toLowerCase() == 'front' && design.id.toLowerCase() != 'common'){
              front = true;
            }
            $(group).children().each((q, item) => {
              if($(item)[0].gradientUnits === undefined) { // check if item is gradient then don't brake its id as it is used as reference on another node
                let elId = $(item).is('[data-name]') ? $(item).attr('data-name') : item.id;
                item.id = elId.split('_')[0];
                if(group.id.toLowerCase() == 'production'){
                  this.setIdFromDataNameRecursively(item); // set id from data-name if exists
                }
              }
            });
          });
          if(design.id.toLowerCase() == 'common'){
            this.common_design = $(design).wrap('<div />').parent().html();
            front = true;
          }

          if((!front) && design.id.toLowerCase() != 'common'){
            this.showToast('Front layer of "'+design.id+'" design is required', 'DANGER');
          }

          newsvg = newsvg.concat($(design).wrap('<div />').parent().html());
        });
        newsvg = newsvg.concat('</svg>');
        this.svg_content = newsvg;

        if(front) {
          let payload = {
            container_id: this.container_id,
            file_id:this.file_id,
            name: this.name,
            size: this.getReadableFileSizeString(this.file.size),
          }
          try{
            let res;
            this.$store.commit('set', ['showLoader', true]);
            if(this.file_id > 0){
              res = await this.$store.dispatch('updateContainerFile', payload);
            }else{
              res = await this.$store.dispatch('addContainerFile', payload);
            }

            this.file_id = res.data.id;
            await this.SendSvg();
            this.$bvModal.hide('fileModal');
          }catch (err){
            this.$store.commit('set', ['showLoader', false]);
            this.showError(err);
          }
        }

      }
    },
    // Function to recursively remove 'display' style or attribute
    removeDisplayNone(element) {
      // Check and remove the display attribute from the element itself
      if ($(element).attr('display') === 'none') {
        $(element).removeAttr('display'); // Remove the 'display' attribute
      }

      // Check and remove inline style for 'display: none'
      if ($(element).css('display') === 'none') {
        $(element).css('display', ''); // Remove inline 'display' style
      }

      // Recursively check all children
      $(element).children().each((index, child) => {
        this.removeDisplayNone(child); // Recursively remove 'display: none' from children
      });
    },
    setIdFromDataNameRecursively(element) {
      // If the element has data-name, set it as id
      if ($(element).is('[data-name]')) {
        element.id = $(element).attr('data-name');
      }

      // Recurse through all children
      $(element).children().each((_, child) => {
        this.setIdFromDataNameRecursively(child);
      });
    },
    getReadableFileSizeString(fileSizeInBytes) {
      let i = -1;
      let byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
      do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
      } while (fileSizeInBytes > 1024);

      return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    },
    async SendSvg() {
      const firstIndex = this.svg_content.indexOf('<');
      let svgheader = this.svg_content.substr(firstIndex + 1, this.svg_content.indexOf('<'));
      let newsvg = '';

      if (svgheader.length <= 0) {
        newsvg = `<?xml version="1.0" encoding="utf-8"?>\n` +
          `<svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" ` +
          `x="0px" y="0px" width="3886.9px" height="4508.3px" viewBox="0 0 3886.9 4508.3" ` +
          `style="enable-background:new 0 0 3886.9 4508.3;" xml:space="preserve">`;
      } else {
        newsvg = svgheader;
      }

      // Pre-extract common elements once
      const commonElements = this.extractCommonElements();
      this.used_files_name = [];

      // Get all designs at once
      const designs = Array.from($(this.svg_content).children()).filter(
        design => design.id.toLowerCase() !== 'common'
      );

      if (!designs.length) {
        this.$store.commit('set', ['showLoader', false]);
        return;
      }

      try {
        // Step 1: Process all designs in parallel (CPU-bound work)
        const processedResults  = await Promise.allSettled(
          designs.map(design => this.processDesignData(design, newsvg, commonElements))
        );

        // Filter successful designs only (non-null values)
        const processedDesigns = processedResults
          .filter(result => result.status === 'fulfilled' && result.value !== null)
          .map(result => result.value);

        // Log failed designs
        const failedCount = processedResults.length - processedDesigns.length;
        
        if (failedCount > 0) {          
          this.showToast(`Skipped ${failedCount} problematic design(s)`, 'ALERT');
        }

        if (processedDesigns.length === 0) {
          this.showToast('No valid designs to upload', 'ALERT');
          this.$store.commit('set', ['showLoader', false]);
          return;
        }

        if(commonElements.sizes){
          processedDesigns.push({
            designId: 'sizes',
            files: [{
              name: 'sizes.svg',
              content: newsvg + commonElements.sizes + '</svg>',
              type: 'sizes'
            }],
            s3MetaPayload: {
              file_name: 'sizes.svg',
              file_type: 'image/svg+xml',
              container_id: this.container_id,
              design_name: 'sizes',
              file_id: this.file_id
            },
            coloring_obj: {},
            extractedParts: {
              front_svg_parts: null,
              back_svg_parts: null,
              production_svg_parts: null,
              text_fields: []
            },
          });
        }
        // Step 2: Get all S3 signed URLs in one batch request
        const allS3MetaPayload = processedDesigns.flatMap(pd => pd.s3MetaPayload);
        this.showToast(`Parsing design files to upload to server.`, 'SUCCESS');
        const signedUrlsRes = await http.post('design-file-s3-url', { files: allS3MetaPayload });
        const signedUrls = signedUrlsRes.data.data;

        const uploadResults = await this.runBatchedPromises(
          processedDesigns.map(pd => () => this.uploadDesignFiles(pd, signedUrls)), 
          8 // Only 8 designs uploading simultaneously (conservative for Mac)
        );

        // Step 4: Process successful uploads for database
        const successfulUploads = uploadResults
          .filter(result => result.status === 'fulfilled' && result.value?.payload)
          .map(result => result.value.payload);

        // Step 5: Update database with all successful uploads at once
        if (successfulUploads.length > 0) {
          try {
            this.showToast(`Storing designs info in database.`, 'SUCCESS');
            await http.post('multiDesignFile', { designs: successfulUploads });
            this.showToast(`Successfully stored ${successfulUploads.length} designs`, 'SUCCESS');
          } catch (bulkError) {            
              const individualTasks = successfulUploads.map(payload => {                         
            }            
            );

            const dbResults = await Promise.allSettled(individualTasks);            
            const dbSuccessCount = dbResults.filter(r => r.status === 'fulfilled').length;
            if (dbSuccessCount === successfulUploads.length) {
              this.showToast('All designs stored successfully', 'SUCCESS');
            } else {
              this.showToast(`${dbSuccessCount}/${successfulUploads.length} designs stored successfully`, 'ALERT');
            }
          }
        }

        // Handle addons if present
        if (this.container_file_addons_content) {
          await this.uploadAddons();
        }

        // Final cleanup and status
        await this.handleFinalCleanup(uploadResults);
      } catch (error) {        
        this.showToast('Failed to upload designs', 'ALERT');
        this.$store.commit('set', ['showLoader', false]);
      }
    },
    // Helper method to extract common elements once
    extractCommonElements() {
      const common = {
        front: '', back: '', sizes: '', production: '', color_grouping: null,
        front_safezone: '', back_safezone: '', production_safezone: '',
        front_boundary: '', back_boundary: ''
      };

      $(this.common_design).children().each((_, design) => {
        const id = design.id.toLowerCase();
        if (id === 'front') common.front = $(design).html();
        else if (id === 'back') common.back = $(design).html();
        else if (id === 'sizes') common.sizes = $(design).html();
        else if (id === 'production') common.production = $(design).html();
        else if (id === 'colorgrouping') common.color_grouping = $(design);
        else if (id === 'safezones') {
          $(design).children().each((_, subdesign) => {
            const sid = subdesign.id.toLowerCase();
            if (sid === 'frontsafezones') common.front_safezone = $(subdesign).html();
            else if (sid === 'backsafezones') common.back_safezone = $(subdesign).html();
            else if (sid === 'productionsafezones') common.production_safezone = $(subdesign).html();
          });
        } else if (id === 'svgboundaries') {
          $(design).children().each((_, subdesign) => {
            const sid = subdesign.id.toLowerCase();
            if (sid === 'frontboundaries') common.front_boundary = $(subdesign).html();
            else if (sid === 'backboundaries') common.back_boundary = $(subdesign).html();
          });
        }
      });

      return common;
    },
    // Process design data (CPU-bound work) - FIXED to match original logic
    async processDesignData(design, newsvg, commonElements) {
      const designId = design.id;
      this.used_files_name.push(designId.trim());
      
      let group_tag = '';
      let frontsafezonedata = '', backsafezonedata = '', productionsafezonedata = '';
      let frontboundarydata = '', backboundarydata = '';
      
      const files = [];
      const extractedParts = {
        front_svg_parts: null,
        back_svg_parts: null,
        production_svg_parts: null,
        text_fields: [],
      };
      const appendTextFields = (parts, fallbackType) => {
        if (!Array.isArray(parts)) return;
        const shouldRemovePart = (part) =>
          typeof part === 'string' &&
            /"type"\s*:\s*"team_name"/i.test(part) ||
            /editabletextfield/i.test(part);
        parts.forEach((part) => {
          if (typeof part !== 'string' || !shouldRemovePart(part)) return;
          try {
            const parsed = safeParse(part);
            if (parsed && parsed.type) {
              extractedParts.text_fields.push(parsed);
              return;
            }
            if (Array.isArray(parsed)) {
              parsed.forEach((entry) => {
                if (entry && typeof entry === 'object') {
                  extractedParts.text_fields.push(entry);
                }
              });
              return;
            }
            if (parsed && typeof parsed === 'object') {
              extractedParts.text_fields.push(parsed);
            }
          } catch (error) {
            extractedParts.text_fields.push({ raw: part, type: fallbackType });
          }
        });
        for (let i = parts.length - 1; i >= 0; i -= 1) {
          if (shouldRemovePart(parts[i])) {
            parts.splice(i, 1);
          }
        }
      };
      const stripEditableTextTag = (content) => {
        if (typeof content !== 'string') return content;
        return content.replace(
          /<g\b[^>]*\bid\s*=\s*["'][^"']*editabletextfield[^"']*["'][^>]*>[\s\S]*?<\/g>/gi,
          ''
        );
      };

      // Process all groups for this design
      const groups = Array.from($(design).children());
      const extractPromises = [];

      for (const group of groups) {
        const gid = group.id.toLowerCase();
        const html = $(group).html();

        if (gid === 'front') {
          const frontTag = `${newsvg}${html}${commonElements.front}</svg>`;
          const cleanedFrontTag = stripEditableTextTag(frontTag);
          files.push({ name: 'front.svg', content: cleanedFrontTag, type: 'front' });
          extractPromises.push(
            extractDesignParts(frontTag, 'front').then(parts => {
              extractedParts.front_svg_parts = parts;
              appendTextFields(parts, 'front');
            })
          );
        } else if (gid === 'back') {
          const backTag = `${newsvg}${html}${commonElements.back}</svg>`;
          const cleanedBackTag = stripEditableTextTag(backTag);
          files.push({ name: 'back.svg', content: cleanedBackTag, type: 'back' });
          extractPromises.push(
            extractDesignParts(backTag, 'back').then(parts => {
              extractedParts.back_svg_parts = parts;
              appendTextFields(parts, 'back');
            })
          );
        } else if (gid === 'production') {
          const prodTag = `${newsvg}${html}${commonElements.production}</svg>`;
          const cleanedProdTag = stripEditableTextTag(prodTag);
          files.push({ name: 'production.svg', content: cleanedProdTag, type: 'production' });
          extractPromises.push(
            extractDesignParts(prodTag, 'production').then(parts => {
              extractedParts.production_svg_parts = parts;
              appendTextFields(parts, 'production');
            })
          );
        } else if (gid === 'safezones') {
          $(group).children().each((_, sg) => {
            const sid = sg.id.toLowerCase();
            if (sid === 'frontsafezones') frontsafezonedata = $(sg).html();
            else if (sid === 'backsafezones') backsafezonedata = $(sg).html();
            else if (sid === 'productionsafezones') productionsafezonedata = $(sg).html();
          });
        } else if (gid === 'svgboundaries') {
          $(group).children().each((_, sg) => {
            const sid = sg.id.toLowerCase();
            if (sid === 'frontboundaries') frontboundarydata = $(sg).html();
            else if (sid === 'backboundaries') backboundarydata = $(sg).html();
          });
        } else if (gid === 'colorgrouping') {
          group_tag = $(group);
        }
      }

      // Add optional files - FIXED to match original conditions
      if (frontsafezonedata || commonElements.front_safezone) {
        const content = `${newsvg}${frontsafezonedata}${commonElements.front_safezone}</svg>`;
        files.push({ name: 'FrontSafeZones.svg', content, type: 'frontsafezone' });
      }
      if (backsafezonedata || commonElements.back_safezone) {
        const content = `${newsvg}${backsafezonedata}${commonElements.back_safezone}</svg>`;
        files.push({ name: 'BackSafeZones.svg', content, type: 'backsafezone' });
      }
      if (productionsafezonedata || commonElements.production_safezone) {
        const content = `${newsvg}${productionsafezonedata}${commonElements.production_safezone}</svg>`;
        files.push({ name: 'ProductionSafeZones.svg', content, type: 'productionsafezone' });
      }
      if (frontboundarydata || commonElements.front_boundary) {
        const content = `${newsvg}${frontboundarydata}${commonElements.front_boundary}</svg>`;
        files.push({ name: 'frontboundary.svg', content, type: 'frontboundary' });
      }
      if (backboundarydata || commonElements.back_boundary) {
        const content = `${newsvg}${backboundarydata}${commonElements.back_boundary}</svg>`;
        files.push({ name: 'backboundary.svg', content, type: 'backboundary' });
      }
      
      await Promise.all(extractPromises);

      // If ANY required part is empty, remove ALL required files
      const requiredTypes = ['front', 'back'];
      const fileTypeToParts = {
        front: extractedParts.front_svg_parts,
        back: extractedParts.back_svg_parts,
        production: extractedParts.production_svg_parts,
        text_fields: extractedParts.text_fields,
      };
      const hasEmptyRequired = requiredTypes.some(type =>
        Array.isArray(fileTypeToParts[type]) && fileTypeToParts[type].length === 0
      );
      if (hasEmptyRequired) {
        // Remove all required files
        requiredTypes.forEach(type => {
          const idx = files.findIndex(f => f.type === type);
        if (idx !== -1) files.splice(idx, 1);
        });        
      }

      // Process color grouping - FIXED to match original logic
      if (!group_tag && commonElements.color_grouping) {
        group_tag = commonElements.color_grouping;
      }
      
      const coloring_obj = {};
      if (group_tag) {
        $(group_tag).find('text').each((_, textTag) => {
          const color_text = $(textTag).text();
          const [label, colors] = color_text.split('/');
          if (label && colors) {
            const colorArr = colors.split(',').map(s => s.trim());
            coloring_obj[label.trim()] = (coloring_obj[label.trim()] || []).concat(colorArr);
          }
        });
      }

      // Prepare S3 metadata
      const s3MetaPayload = files.map(file => ({
        file_name: file.name,
        file_type: 'image/svg+xml',
        container_id: this.container_id,
        design_name: designId,
        file_id: this.file_id
      }));

      return {
        designId,
        files,
        s3MetaPayload,
        coloring_obj,
        extractedParts
      };
    },
    // Upload files for a single design using original retry logic
    async uploadDesignFiles(processedDesign, signedUrls) {
      const { designId, files, coloring_obj, extractedParts } = processedDesign;
      this.showToast(`Uploading design files for ${designId}.`, 'SUCCESS');
      // Use original FormData approach but in parallel
      const uploadTasks = files.map(async (file) => {
        const url = signedUrls[designId][file.name];
        if (!url) {
          this.showToast(`No signed URL for ${file.name} in ${designId}.`, 'ALERT');
          return { type: file.type, success: false };
        }
        
        // Create FormData for this file (matching original approach)
        const tempForm = new FormData();
        const blob = new File([file.content], file.name, { type: 'image/svg+xml' });
        tempForm.append('file', blob);
        tempForm.append('signed_url', url);
        
        const success = await this.retryUploadToSignedUrl(tempForm);
        
        if (success) {
          const fileUrl = url.split('?')[0];
          return { type: file.type, success: true, url: fileUrl };
        } else {
          this.showToast(`Failed to upload ${file.name} for ${designId}.`, 'ALERT');
          return { type: file.type, success: false };
        }
      });

      const uploadResults = await Promise.all(uploadTasks);
      
      // Build payload with uploaded file URLs
      const designUploads = {
        design_name: designId,
        container_id: this.container_id,
        file_id: this.file_id,
        color_group: JSON.stringify(coloring_obj),
        front_svg_parts: extractedParts.front_svg_parts || null,
        back_svg_parts: extractedParts.back_svg_parts || null,
        production_svg_parts: extractedParts.production_svg_parts || null,
        text_fields: extractedParts.text_fields || []
      };

      // Map successful uploads to payload (preserving original field names)
      uploadResults.forEach((result) => {
        if (result.success) {
          designUploads[result.type] = result.url;
        }
      });
      if(designId !== 'sizes'){
        const requiredFiles = ["front", "back", "production"];
        const missingFiles = requiredFiles.filter(k => !designUploads[k]);
        // Validate required files (same validation as original)
        if (missingFiles.length > 0) {
          this.showToast(
            `Skipping ${designId}: Missing required ${missingFiles.join(', ')} file(s).`,
            'ALERT'
          );
          return { status: 'failed', designId };
        }
      }
      return { status: 'success', payload: designUploads, designId };
    },
    // Enhanced batching with better concurrency control
    async runBatchedPromises(tasks, batchSize = 10) {
      const results = [];
      
      for (let i = 0; i < tasks.length; i += batchSize) {
        const batch = tasks.slice(i, i + batchSize);
        const batchResults = await Promise.allSettled(
          batch.map(task => typeof task === 'function' ? task() : task)
        );
        results.push(...batchResults);
      }
      
      return results;
    },
    async handleFinalCleanup(uploadResults) {
      const allSuccess = uploadResults.every(r => 
        r.status === 'fulfilled' && r.value?.status === 'success'
      );
      
      this.$store.commit('set', ['showLoader', false]);

      if (allSuccess) {
        this.showToast('All files uploaded successfully', 'SUCCESS');
      } else {
        const successCount = uploadResults.filter(r => 
          r.status === 'fulfilled' && r.value?.status === 'success'
        ).length;
        this.showToast(`${successCount}/${uploadResults.length} designs uploaded successfully`, 'ALERT');
      }

      await this.extractAddonsFromSvgFile();

      // Handle file cleanup for updates - PRESERVED original logic
      if (this.file_action === 'update') {
        const deletePayload = {
          container_id: this.container_id,
          file_id: this.file_id,
          used_files_name: this.used_files_name
        };
        this.$store.commit('set', ['showLoader', true]);
        
        try {
          const resp = await http.post('designfile/delete-files', deletePayload);
          this.showToast(resp.data.message, 'ALERT');
        } catch (error) {
          console.error('Cleanup failed:', error);
        } finally {
          this.$store.commit('set', ['showLoader', false]);
        }
      }
    },
    // Upload addons separately - PRESERVED original logic
    async uploadAddons() {
      const addonsBlob = new Blob([this.container_file_addons_content], { type: 'image/svg+xml' });
      const addonsForm = new FormData();
      addonsForm.append('container_addons', addonsBlob, 'container_file_addons.svg');
      addonsForm.append('container_id', this.container_id);
      
      try {
        await http.post('add_update_container_file_addons', addonsForm);
      } catch (error) {
        console.error('Addons upload failed:', error);
        this.showToast('Failed to upload addons', 'ALERT');
      }
    },
    async extractAddonsFromSvgFile() {
      // Parse the SVG content as an XML document
      let parser = new DOMParser();
      let svgDoc = parser.parseFromString(this.svg_content, "image/svg+xml");

      // Find the element with ID 'ADDON'
      const addon_container = svgDoc.querySelector('[id="ADDON"]');
      const grouped_addons_container = svgDoc.querySelector('[id="grouped-addons"]');
      const ungrouped_addons_container = svgDoc.querySelector('[id="ungrouped-addons"]');

      if (grouped_addons_container || ungrouped_addons_container) {
        // Get the root <svg> element
        let svg_node = svgDoc.documentElement;

        // Remove all child elements from the <svg> node
        while (svg_node.firstChild) {
          svg_node.removeChild(svg_node.firstChild);
        }

        // Append the addon_container to the <svg> node
        svg_node.appendChild(addon_container);

        // Serialize the updated SVG back to a string
        let serializer = new XMLSerializer();
        this.container_file_addons_content = serializer.serializeToString(svg_node);
      }
    }
  }
}
</script>
<style scoped>
  .container_row{
    background-color: #dedede;
    padding: 10px 0;
    border-bottom: 1px solid #dede;
  }
  .files_row{
    padding: 10px 0;
    border-bottom: 1px solid #dddddd;
  }
  .actions{
    cursor: pointer;
  }
</style>